import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LabsRouteGuardService implements CanActivate {
  apiUrl = window.apiUrl;
  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}
  canActivate(): Observable<boolean | UrlTree> {
    return new Observable((observer) => {
      this.http
        .get(`${this.apiUrl}/api/get_user_default_data?data=1`)
        .subscribe((mexData: any) => {
          if (mexData.is_lab_access_url || mexData.is_sellside) {
            observer.next(mexData.is_lab_access_url || mexData.is_sellside);
          } else {
            const urlTree: UrlTree = this.router.parseUrl("/home");
            observer.next(urlTree);
          }
          observer.complete();
        });
    });
  }
}
